<h1 mat-dialog-title>Logged Out</h1>
<div mat-dialog-content>Your Session timed out, Please Login Again!</div>
<div mat-dialog-actions style="float: right;">
    <button mat-raised-button color="warn" mat-dialog-close >Close</button>
</div>